import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "address-selector-refactored" }
const _hoisted_2 = { class: "address-selector-refactored__menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_aux_selector = _resolveComponent("aux-selector")!
  const _component_inline_descriptor = _resolveComponent("inline-descriptor")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_inline_descriptor, {
      ref: "inlineDescriptorRef",
      id: `address-refactored-${_ctx.id}`,
      "model-value": _ctx.computedModel,
      schema: _ctx.computedSchema,
      separators: _ctx.separators,
      editable: true,
      "enable-menu": true,
      "move-to-body": true,
      "menu-z-index": _ctx.menuZIndex,
      "onUpdate:modelValue": _ctx.onUpdateModelValue,
      onUpdateMenu: _ctx.handleUpdateMenu,
      onKeydown: [
        _withKeys(_withModifiers(_ctx.onArrowUp, ["exact","prevent"]), ["up"]),
        _withKeys(_withModifiers(_ctx.onArrowDown, ["exact","prevent"]), ["down"]),
        _withKeys(_withModifiers(_ctx.onEnter, ["exact","prevent"]), ["enter"]),
        _withKeys(_withModifiers(_ctx.closeMenu, ["exact","prevent"]), ["esc"])
      ]
    }, {
      "menu-content": _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_aux_selector, {
            ref: "auxSelectorRef",
            style: {"min-width":"320px","height":"100%"},
            "show-search-header": false,
            "limit-height-to-container": true,
            "allow-free-input": false,
            "allow-multiple": false,
            "model-type": _ctx.AuxSelectorDataType.AddressHints,
            "filter-model-value": _ctx.auxFilterString,
            "component-model": _ctx.componentModel,
            "model-value": _ctx.selectedHints,
            "onUpdate:modelValue": _ctx.onHintsModelUpdate,
            onSelectorClosed: _ctx.onSelectorClosed
          }, null, 8, ["model-type", "filter-model-value", "component-model", "model-value", "onUpdate:modelValue", "onSelectorClosed"])
        ])
      ]),
      _: 1
    }, 8, ["id", "model-value", "schema", "separators", "menu-z-index", "onUpdate:modelValue", "onUpdateMenu", "onKeydown"]),
    _withDirectives(_createVNode(_component_q_icon, {
      class: "pointer hover-green q-ml-sm",
      style: {"align-self":"baseline"},
      name: "arrow_back",
      size: "18px",
      color: "grey-7",
      title: "clear",
      onClick: _withModifiers(_ctx.clearAddressModel, ["stop","prevent"])
    }, null, 8, ["onClick"]), [
      [_vShow, _ctx.showClear && _ctx.hasFilterValue]
    ]),
    (_ctx.showDelete)
      ? (_openBlock(), _createBlock(_component_q_btn, {
          key: 0,
          class: "q-px-none q-mx-none unset-items-center",
          style: {"margin-top":"1px"},
          flat: "",
          dense: "",
          "aria-label": _ctx.$t('delete_filter'),
          icon: "close",
          size: "sm",
          tabindex: "-1",
          color: "grey-8",
          onClick: _withModifiers(_ctx.emitDelete, ["stop","prevent"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_tooltip, { delay: 1000 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('remove')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["aria-label", "onClick"]))
      : _createCommentVNode("", true)
  ]))
}